import {faker}  from "@faker-js/faker";
import { getAccounts } from "../helpers/get-accounts";
import { regions } from "./regions";
import resourceList from "../../utils/resourceList.json";
const status = ["COMPLETED"];
const regionData = (showOnlyCompletedStatus) => {
  const statusList = showOnlyCompletedStatus
    ? ["COMPLETED"]
    : ["PENDING", "COMPLETED"];
  const resourceTypes = Object.keys(resourceList);
  let resourceData = [];
  resourceTypes.forEach((resource) => {
    resourceData.push({
      ResourceType: resource,
      Status: faker.helpers.arrayElement(statusList),
    });
  });
  return resourceData;
};

const resourceCount = [
  23, 213, 21, 45, 73, 24, 67, 123, 51, 33, 23, 43, 65, 95, 12, 32,
];

export const getResourceCount = (regionCode, showOnlyCompletedStatus) => {
  let count = faker.helpers.arrayElement(resourceCount);
  switch (regionCode) {
    case "us-east-1":
      count = !showOnlyCompletedStatus ? 227 : 312;
      break;
    case "us-east-2":
      count = !showOnlyCompletedStatus ? 98 : 186;
      break;
    case "eu-west-1":
      count = !showOnlyCompletedStatus ? 177 : 278;
      break;
    default:
      break;
  }
  return count;
};

export const organizationSummary = async (
  accountList,
  regionList,
  resourceList,
  showOnlyCompletedStatus
) => {
  //STATUS  - COMPLETED, COMPLETED, FAILED
  let accounts = await getAccounts();
  if (accountList) {
    accounts = accountList;
  }

  let resourceSummary = [
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Instance",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 3005,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Lambda",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 3,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "SecurityGroup",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 11,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Cfn",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 15,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Vpc",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 30,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Snapshot",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 20,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Volume",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 35,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Rds",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 0,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "S3",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 2,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Subnet",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 6,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "CloudWatchEventRule",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 15,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "IAMRole",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 9,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Topic",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 15,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "IAMPolicy",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 2,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "PeeringConnection",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 0,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "FileSystem",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 0,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "ElasticIp",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 0,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Repository",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 0,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Certificate",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 0,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Image",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 200,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "KMSKey",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 0,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "HostedZone",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 0,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "VpcEndpoint",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 30,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "RouteTable",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 1,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "LoadBalancer",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 0,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "DynamoDbTable",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 0,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "AutoScalingGroup",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 0,
    },
    {
      OrgId: "",
      AccountNumber: "",
      ResourceType: "Workspace",
      Status: faker.helpers.arrayElement(status),
      ResourceCount: 0,
    },
  ];
  if (resourceList) {
    resourceSummary = resourceSummary.filter((resource) => {
      return resourceList.some((ele) => ele === resource.ResourceType);
    });
  }

  let totalResourceCount = resourceSummary.reduce(
    (count, summary) => count + summary.ResourceCount,
    0
  );

  let regionSummary = [];
  let accountSummary = [];
  [...regions].reverse().forEach((region, index) => {
    const accountNumber = faker.helpers.arrayElement(accounts);
    const isLastIndex = index === regions.length - 1;

    const resourceCount = isLastIndex
      ? totalResourceCount
      : Math.floor(totalResourceCount / regions.length);
    totalResourceCount -= resourceCount;
    const _regionDetails = {
      OrgId: "f54283ad-de00-40a2-8bee-e96fb7dced33",
      AccountNumber: accountNumber,
      Region: region.RegionCode,
      Status: !showOnlyCompletedStatus
        ? "PENDING"
        : faker.helpers.arrayElement(status),
      ResourceCount: resourceCount,
      ResourceDetail: regionData(showOnlyCompletedStatus),
    };
    regionSummary.push(_regionDetails);
    const accIndex = accountSummary.findIndex(
      (acc) => acc.Account === accountNumber
    );
    if (accIndex >= 0) {
      accountSummary[accIndex].ResourceCount =
        accountSummary[accIndex].ResourceCount + _regionDetails.ResourceCount;
    } else {
      accountSummary.push({
        Account: accountNumber,
        ResourceCount: _regionDetails.ResourceCount,
      });
    }
  });

  if (regionList) {
    regionSummary = regionSummary.filter((region) =>
      regionList.includes(region.Region)
    );
  }
  const orgSummary = {
    Summary: !showOnlyCompletedStatus
      ? "PENDING"
      : faker.helpers.arrayElement(status),
    RegionSummary: regionSummary,
    ResourceSummary: resourceSummary,
    AccountSummary: accountSummary,
  };
  return orgSummary;
};

export const appSummary = async (appId) => {
  //STATUS  - COMPLETED, COMPLETED, FAILED
  let accounts = await getAccounts();
  return {
    Summary: faker.helpers.arrayElement(status),
    RegionSummary: [
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "us-east-1",
        ResourceCount: 26,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "us-east-2",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "us-west-1",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "us-west-2",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "ap-south-1",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "ap-northeast-2",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "ap-southeast-1",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "ap-southeast-2",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "ap-northeast-1",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "ca-central-1",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "eu-central-1",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "eu-west-1",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "eu-west-2",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "eu-west-3",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "eu-north-1",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "sa-east-1",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "eu-north-1",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        AccountNumber: faker.helpers.arrayElement(accounts),
        Region: "global",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
    ],
    ResourceSummary: [
      {
        ResourceType: "Cfn",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "CloudWatchEventRule",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "Instance",
        ResourceCount: 6,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "Lambda",
        ResourceCount: 3,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "Rds",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "S3",
        ResourceCount: 2,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "SecurityGroup",
        ResourceCount: 1,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "Snapshot",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "Subnet",
        ResourceCount: 4,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "Volume",
        ResourceCount: 8,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "Vpc",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "IAMRole",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "Topic",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "IAMPolicy",
        ResourceCount: 2,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "PeeringConnection",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "FileSystem",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "ElasticIp",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "Repository",
        ResourceCount: 0,
        Status: faker.helpers.arrayElement(status),
      },
      {
        ResourceType: "Workspace",
        ResourceCount: 6,
        Status: faker.helpers.arrayElement(status),
      },
    ],
  };
};
